module.exports = __webpack_public_path__ + "img/tutorialScreenshot.060be3d9.png";